import React from 'react'
import {
    TableCell,
    TableHead,
    TableRow,
    Table,
} from '@material-ui/core';
import { Paper } from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const BankCustomerSearchData = this.props.BankCustomerSearchData;
        const BankCustomerList = this.props.BankCustomerList;
        const BankCustomerData = this.props.BankCustomerData;

        return (
            <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
                <div>
                    <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                        <br />
                        <h2><center>Bought Leaf Balance Payment Bank Customer List</center></h2>
                        <div>&nbsp;</div>
                        <h3><center>{BankCustomerSearchData.groupName} - {BankCustomerSearchData.factoryName}</center></h3>
                        <div>&nbsp;</div>
                        <h3><center>Bank - {BankCustomerList.bankID == '0' ? "All Banks" : BankCustomerData[0].bankName}</center></h3>
                        <div>&nbsp;</div>
                        <h3><center>Branch - {BankCustomerList.branchID == '0' ? "All Branches" : BankCustomerData[0].branchName}</center></h3>
                        <div>&nbsp;</div>
                        <h3><center>BOUGHT LEAF BALANCE PAYMENT FOR THE MONTH OF {BankCustomerSearchData.applicableMonth} - {BankCustomerSearchData.applicableYear}</center></h3>
                        <div>&nbsp;</div>
                        <div>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow style={{ border: "2px solid black" }}>
                                        <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Branch</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Account Number</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Name</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Amount</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Remark</TableCell>
                                    </TableRow>
                                </TableHead>
                                {BankCustomerData.map((row, i) => (
                                    <TableRow style={{ border: "2px solid black" }} key={i}>
                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}> {row.branchName}</TableCell>
                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", width: '20%' }}> {row.accountNumber}</TableCell>
                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}> {row.name}</TableCell>
                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", width: '20%' }}>{row.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                ))}
                            </Table>
                        </div>
                        <div>&nbsp;</div>
                        <h4><center>*******End of List*******</center></h4>
                    </div></div>
            </Paper>
        );
    }
}
